import React, { useState } from "react";
import styles from "./ProductDevelopmentForm.module.css";
import { Field, Formik, Form } from "formik";
import {
  Button,
  InputGroup,
  Form as BootstrapForm,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import * as Yup from "yup";
import { submitFormProductDevelopment } from "../../actions/Form.action";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { MultiSelect } from "@mantine/core";

const ProductDevelopmentForm = ({ submitFormProductDevelopment, data }) => {
  const [submitting, setSubmitting] = useState(false);
  const [file, setFile] = useState(false);
  const navigate = useNavigate();
  const onSubmitHandeler = async (values) => {
    setSubmitting(true);
    if (!file) {
      toast.error("Please upload file!");
      setSubmitting(false);
      return;
    }
    if (Object.keys(data).length === 0) {
      toast.error("Please fill these fields!");
      setSubmitting(false);
      navigate("/order");
      return;
    }
    let check = await submitFormProductDevelopment(values, data, file);
    if (check === true) {
      setSubmitting(false);
      navigate(`/`);
    } else {
      setSubmitting(false);
    }
  };
  let initVals = {
    includes: [],
    quality: "",
    features: "",
  };

  const OrderSchema = Yup.object().shape({
    includes: Yup.array().notRequired(),
    quality: Yup.string().required("Quality is required!"),
    features: Yup.string().required("Features  is required!"),
  });

  return (
    <div className={styles.wrapper}>
      <h2 className="pt-4 px-5">Product Design & Manufacturing Order</h2>
      <Formik
        initialValues={initVals}
        validationSchema={OrderSchema}
        enableReinitialize
        onSubmit={(values) => onSubmitHandeler(values)}
      >
        {({ errors, touched, setFieldValue, values }) => (
          <Form>
            <Container className="p-md-5 p-3 pt-3 pt-md-3">
              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="includes" className="d-block">
                        Includes
                      </label>
                      {errors.includes && touched.includes ? (
                        <small className="text-danger">{errors.includes}</small>
                      ) : null}
                    </div>
                    <Field
                      as={MultiSelect}
                      data={[
                        "Product Execution Consultancy",
                        "CAD Design",
                        "Electronics Design",
                        "Microcontroller Programming",
                        "Software Development",
                        "Web Development",
                        "Manufacturing",
                      ]}
                      onChange={(e) => setFieldValue("includes", e)}
                      searchable
                      creatable
                      value={values.includes}
                      getCreateLabel={(query) => `+ Create ${query}`}
                      onCreate={(query) => {
                        const item = { value: query, label: query };
                        return item;
                      }}
                      placeholder="Type includes..."
                      name="includes"
                      isValid={!errors.includes && touched.includes}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.includes && touched.includes}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="quality" className="d-block">
                        Quantity
                      </label>
                      {errors.quality && touched.quality ? (
                        <small className="text-danger">{errors.quality}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type the quality you need..."
                      name="quality"
                      isValid={!errors.quality && touched.quality}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.quality && touched.quality}
                    ></Field>
                  </InputGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <InputGroup className="mb-3 d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-center pb-2">
                      <label htmlFor="features" className="d-block">
                        Features needed in details
                      </label>
                      {errors.features && touched.features ? (
                        <small className="text-danger">{errors.features}</small>
                      ) : null}
                    </div>
                    <Field
                      as={BootstrapForm.Control}
                      placeholder="Type features you need..."
                      name="features"
                      isValid={!errors.features && touched.features}
                      type="text"
                      className={`${styles.input} w-100`}
                      isInvalid={errors.features && touched.features}
                    />
                  </InputGroup>
                </Col>
                <Col md={6}>
                  <BootstrapForm.Group controlId="formFile" className="mb-3">
                    <BootstrapForm.Label>
                      Product Development Files *
                    </BootstrapForm.Label>
                    <BootstrapForm.Control
                      onChange={(e) => setFile(e.target?.files)}
                      type="file"
                      multiple
                    />
                  </BootstrapForm.Group>
                </Col>
              </Row>

              <Row>
                <Col className="pt-3 d-flex justify-content-center align-items-center">
                  <Button
                    type="submit"
                    className={`.btn_primary ${styles.btn}`}
                    disabled={submitting}
                  >
                    {submitting ? "Submitting..." : "Order"}
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        )}
      </Formik>
    </div>
  );
};
const mapStateToProps = (state) => ({
  data: state.form.form,
});
export default connect(mapStateToProps, { submitFormProductDevelopment })(
  ProductDevelopmentForm
);
